<template>
    <button class="btn btn-primary btn-sm m-r show-balance-modal" :disabled="disabled" @click="showModal">{{ __('generate_balance') }}</button>
</template>

<script>
    import mutations from './../vuex/mutation_types.js'
    import {Money} from './../services/Money.js';
    import events from './../services/Events.js';
    import actions from "../vuex/action_types";
    import generateActionBalance from "../vuex/modal_generate_root_operation_balance/action_types"
    import actions_lock from "../vuex/contractor_history/action_types";
    export default {
        name: "button-show-modal-generate-balance",
        data: function() {
            return {
                disabled: true,
                money: new Money(),
            }
        },
        methods: {
          showModal() {
            let input_data = {
              operations: this.$store.getters.getSelectedOperations,
              documents: this.$store.getters.getSelectedDocuments,
              url: $('#current-url-to-lock').val(),
              route:$('#current-route-to-lock').val()
            };

            if (input_data.operations.length >= 1 || input_data.documents.length >= 1) {
              this.checkIfConnected(input_data);
            }

          },
          checkIfConnected: function (input_data) {
              const self = this;
            this.$store.dispatch(actions.CHECK_CAN_CONNECT, input_data)
                .then((response) => {
                  if (response.data.can_connect == 'false') {
                    window.location = response.data.redirect_url;
                  }
                  else{
                      const selected = this.$store.getters.getSelected;
                      if(this.hasGlobalSourceContractor(selected)){
                          this.getShowModalEventName()
                      }
                      else{
                          events.$emit(self.getShowModalEventName(), []);
                      }

                  }
                })
          },
            getShowModalEventName() {
                const selected = this.$store.getters.getSelected;
                const self = this;
                let hasGlobalSourceContractor = this.hasGlobalSourceContractor(selected);

                if(hasGlobalSourceContractor){
                    let operation = this.getSelectedOperation()
                    swal({
                        title: $.i18n._("generate_balance"),
                        text: $.i18n._("generating_balance_will_move_to_source_contractor"),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        confirmButtonText: $.i18n._("save"),
                        cancelButtonText: $.i18n._("cancel"),
                        closeOnConfirm: true
                    }, function (isConfirm) {
                        if(isConfirm){
                            self.$store.dispatch(generateActionBalance.MODAL_GENERATE_ROOT_OPERATION_BALANCE_SAVE, { operation: operation })
                                .then(response => {
                                    window.location.reload();
                                })
                                .catch(error => {
                                    console.log(error.response.data.message);
                                    toastr['error'](this.__('failed_to_perform_action')).css('border', '0px');
                                    this.submitted = false;
                                });
                        }
                        else{
                            let input_data = {
                                operations: self.$store.getters.getSelectedOperations,
                                documents: self.$store.getters.getSelectedDocuments
                            };
                            self.$store.dispatch(actions_lock.DELETE_LOCKS, input_data)
                        }

                    });
                }
                else{
                    return 'showGenerateBalanceModal';
                }
                return hasGlobalSourceContractor ? 'generateSourceContractorBalanceModal:show' : 'showGenerateBalanceModal';
            },
            getSelectedOperation() {
                const selected = this.$store.getters.getSelected;

                if(selected.length === 1
                    && selected[0].source_type === 'OPERATION'
                    && selected[0].operation_root_is_global == 1
                ) {
                    return selected[0];
                } else {
                    throw new Error('selected operation cannot be subject to this action, or no operation selected')
                }
            },
            hasGlobalSourceContractor(selected){
              return selected.length === 1
                  && selected[0].source_type === 'OPERATION'
                  && selected[0].operation_root_is_global == 1
            }
        },
        created: function() {
            this.$store.subscribe((mutation, state) => {

                if([mutations.ADD_SELECTED, mutations.REMOVE_SELECTED].includes(mutation.type)) {
                    const selected = this.$store.getters.getSelected;
                    let balance = 0
                    if(selected.length === 1){
                      balance = (selected[0].balance === undefined) ? (this.money.toFloat(selected[0].target_amount)) : (selected[0].balance)
                    }
                    const canGenerateBalance = (selected.length === 1 && balance != 0)

                    this.disabled = !(canGenerateBalance);
                    if(canGenerateBalance){
                        if(selected[0].has_access_generate_balance){
                            this.disabled = false;
                        }
                        else{
                            this.disabled = true;
                        }
                    }

                    if(canGenerateBalance && selected[0].has_access_generate_balance) {
                        let generateBalanceData = {
                            amount: this.money.localize(balance),
                            currency: selected[0].currency,
                            balance_url: selected[0].balance_url
                        };
                        this.$store.commit(mutations.SET_MODAL_GENERATE_BALANCE_DATA, generateBalanceData )
                    } else {
                        this.$store.commit(mutations.SET_MODAL_GENERATE_BALANCE_DATA, {amount: 0, currency: '', balance_url: undefined} )
                    }
                }
            });
        },
    }
</script>

<style scoped>

</style>
